interface ISvgContactProps {
    height: number | string;
    width: number | string;
    color: string;
}

const SvgContact: React.FC<ISvgContactProps> = (props) => {
    return (
        <svg width={props.width} height={props.height} viewBox="0 0 60 61" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M32.925 10.5L45 22.575V50.5H15V10.5H32.925ZM35 5.5H15C12.25 5.5 10 7.75 10 10.5V50.5C10 53.25 12.25 55.5 15 55.5H45C47.75 55.5 50 53.25 50 50.5V20.5L35 5.5ZM30 35.5C32.75 35.5 35 33.25 35 30.5C35 27.75 32.75 25.5 30 25.5C27.25 25.5 25 27.75 25 30.5C25 33.25 27.25 35.5 30 35.5ZM40 44.075C40 42.05 38.8 40.25 36.95 39.45C34.825 38.525 32.475 38 30 38C27.525 38 25.175 38.525 23.05 39.45C21.2 40.25 20 42.05 20 44.075V45.5H40V44.075Z"
                fill={props.color}
            />
        </svg>
    );
};

export default SvgContact;
